import React, { FC } from 'react'

import { GenericFeedbackPage, Loader } from 'components'

import { useUnknownErrorPage } from '../hooks'

const UnknownErrorPage: FC = () => {
  const { isLoading, content, button } = useUnknownErrorPage()

  if (isLoading) return <Loader />

  return (
    <GenericFeedbackPage
      icon={content.icon}
      iconColor="var(--error500)"
      title={content.title}
      details={content.details}
      confirmButton={button}
    />
  )
}

export { UnknownErrorPage }
